import { getPlaybackCapability } from '@zattoo/playback-sdk-react-native-zapi';
import { convertAssetType, convertPlaybackState, convertDeviceCapabilities, } from './utils';
import { errorPlayerContainerNotCreated, errorPlayerNotCreated, } from './errors';
import { ContainerType, } from '../player-container';
export const playerGetProperties = async (container) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    switch (container.getContainerType()) {
        case ContainerType.PLAYER: {
            const player = container.getPlayer();
            const capabilities = await getPlaybackCapability();
            return {
                properties: {
                    prePadding: -1,
                    postPadding: -1,
                    isLive: false,
                    assetType: convertAssetType(player.assetType),
                    seekableRange: player.seekableRange ?? undefined,
                    currentState: convertPlaybackState(player.currentState),
                    isStatsForNerdsEnabled: player.isStatsForNerdsEnabled,
                    duration: player.duration ?? undefined,
                    volume: player.volume,
                    currentPosition: player.currentPosition ?? undefined,
                    // ToDo: https://zattoo2.atlassian.net/browse/PLY-1814
                    canSeekForward: player.canSeekForward,
                    canSeekBackward: player.canSeekBackward,
                    canPause: player.canPause,
                    deviceCapabilities: convertDeviceCapabilities(capabilities),
                },
            };
        }
        case ContainerType.PLAYER_ZAPI: {
            const player = container.getPlayerZapi();
            const capabilities = await getPlaybackCapability();
            return {
                properties: {
                    prePadding: player.prePadding,
                    postPadding: player.postPadding,
                    isLive: player.isLive,
                    assetType: convertAssetType(player.assetType),
                    seekableRange: player.seekableRange ?? undefined,
                    currentState: convertPlaybackState(player.currentState),
                    isStatsForNerdsEnabled: player.isStatsForNerdsEnabled,
                    duration: player.duration ?? undefined,
                    volume: player.volume,
                    currentPosition: player.currentPosition ?? undefined,
                    // ToDo: https://zattoo2.atlassian.net/browse/PLY-1814
                    canSeekForward: player.canSeekForward,
                    canSeekBackward: player.canSeekBackward,
                    canPause: player.canPause,
                    deviceCapabilities: convertDeviceCapabilities(capabilities),
                },
            };
        }
        default:
            throw errorPlayerNotCreated;
    }
};
